import React, { Component } from 'react'

class InstagramImage extends Component {
  constructor () {
    super()
    this.state = {
      error: null
    }
    this.handleError = this.handleError.bind(this)
  }
  handleError () {
    this.setState({ error: true })
  }
  render () {
    const { imageSrc } = this.props
    const { error } = this.state

    return !error && <img onError={this.handleError} src={imageSrc} />
  }
}

export default InstagramImage



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/InstagramImage.js